import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-council',
  templateUrl: './student-council.component.html',
  styleUrls: ['./student-council.component.scss']
})
export class StudentCouncilComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
